var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.is_known)?_c('span',{staticClass:"availability-toggle"},[_c('vb-checkbox',{attrs:{"vb_options":{
      switch: true,
      text: 'Mostra in base al credito',
      value: _vm.active,
    }},on:{"change":(value) => _vm.$emit('toggle', value)}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }